import React from 'react';

import type { RouteMatch } from '@confluence/route/entry-points/Route.ts';
import { PRODUCT_HOME_ID } from '@confluence/app-navigation/entry-points/navigationIDs.ts';
import { LoadablePaint } from '@confluence/loadable';

const QuestionsRouteComponent = LoadablePaint({
	loader: () =>
		import(
			/* webpackChunkName: "loadable-QuestionsRouteComponent" */ './QuestionsRouteComponent.tsx'
		),
});

export const GlobalQuestionRoute: {
	({ params: { questionId, spaceKey } }: RouteMatch): React.JSX.Element;
	NAVIGATION_PARAMS({ params: { questionId } }: RouteMatch): {
		Screen: {
			screenEvent: {
				name: string;
				questionId: string;
			};
		};
		MainLayout: {
			navView: string;
		};
	};
} = ({ params: { questionId, spaceKey } }: RouteMatch): React.JSX.Element => {
	return <QuestionsRouteComponent questionId={questionId} spaceKey={spaceKey} isGlobalPage />;
};

GlobalQuestionRoute.NAVIGATION_PARAMS = ({
	params: { questionId },
}: RouteMatch): {
	Screen: {
		screenEvent: {
			name: string;
			questionId: string;
		};
	};
	MainLayout: {
		navView: string;
	};
} => ({
	Screen: {
		screenEvent: {
			name: 'globalQuestionScreen',
			questionId,
		},
	},

	MainLayout: {
		navView: PRODUCT_HOME_ID,
	},
});
